// extracted by mini-css-extract-plugin
var _1 = "alert-module_errorButtonWrap_eIEDb";
var _2 = "alert-module_errorClose_WgQTm";
var _3 = "alert-module_errorText_E4CdT";
var _4 = "alert-module_errorWrap_tz0fn";
var _5 = "alert-module_successButtonWrap_mkWNF";
var _6 = "alert-module_successClose_EBEgD";
var _7 = "alert-module_successText_GK_1G";
var _8 = "alert-module_successWrap_yANAi";
export { _1 as "errorButtonWrap", _2 as "errorClose", _3 as "errorText", _4 as "errorWrap", _5 as "successButtonWrap", _6 as "successClose", _7 as "successText", _8 as "successWrap" }
